import React from "react";

class Start_Main_Or extends React.Component {
    render() {
        return(
            <div className="start_main_or_section">
                <div className="start_main_hr_div"><div className="start_main_hr"></div></div>
                <div className="start_main_or_text">Or</div>
                <div className="start_main_hr_div"><div className="start_main_hr"></div></div>
            </div>
        )
    }
}

export default Start_Main_Or;